import styles from './Report.module.scss';

export const ReportHeader = (props) => <div className={styles.header} {...props}></div>;
